import { render, staticRenderFns } from "./TransactionHistory_Learner.vue?vue&type=template&id=569c704f&"
import script from "./TransactionHistory_Learner.vue?vue&type=script&lang=js&"
export * from "./TransactionHistory_Learner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports